import React from 'react'

import Button from '@/components/button/button'
import Player from '@/components/video/player/player'

import * as style from './footer-download.module.scss'

type FooterDownloadProps = Queries.DatoCmsBannerWithCta

const FooterDownload: React.FC<FooterDownloadProps> = ({
  title,
  text,
  cta,
  background
}) => {
  const isVideo = Boolean(background?.isImage) === false ?? true

  const thisCta = cta && cta.length > 0 ? cta?.[0] : null

  return (
    <section className={style.section}>
      {background && isVideo && (
        <>
          <div className={style.cover} />
          <div className={style.video}>
            <Player
              video={background.url}
              preview={false}
              autoPlay
              muted
              loop
              controls={false}
              classes={{ wrapper: style.wrapperPlayer }}
            />
          </div>
        </>
      )}
      <div className={style.wrapperText}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-9 col-xl-6">
              <h2 className={`${style.title} h300 text-base-1000`}>{title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <p className={`${style.text} b200 text-base-1000`}>{text}</p>
            </div>
            <div className="col-12">
              {thisCta && (
                <Button
                  className={style.button}
                  title={thisCta?.text}
                  isBgDark
                  to={thisCta?.link ?? ''}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterDownload
